export default __webpack_public_path__ + "static/media/outline-dashboard.5877a7b5.svg";